import { alipayJSBridgeReady } from "../utils";
export default function call(apiName, options) {
  var env = window;
  alipayJSBridgeReady(function () {
    env.AlipayJSBridge.call(apiName, options, function (res) {
      var _a = options || {},
        success = _a.success,
        fail = _a.fail,
        complete = _a.complete;
      if (res.error) {
        fail === null || fail === void 0 ? void 0 : fail(res);
      } else {
        success === null || success === void 0 ? void 0 : success(res);
      }
      complete === null || complete === void 0 ? void 0 : complete(res);
    });
  });
}